export interface ICustomer {
  claim_code?: string;
  customer_code?: string;
  customer_name?: string;
  representative_name: string;
  industry_code: string;
  postal_code?: string;
  prefecture_name?: string;
  tel_number?: string;
  prefecture_code?: string;
  address_1?: string;
  address_2?: string;
  account_authority?: string;
  account_authority_name?: string;
}

export class CustomerDTO implements ICustomer {
  claim_code = "";
  customer_code = "";
  customer_name? = "";
  representative_name = "";
  industry_code = "";
  postal_code = "";
  prefecture_name = "";
  tel_number = "";
  prefecture_code = "";
  address_1 = "";
  address_2 = "";
  account_authority? = "1";
  account_authority_name? = "";
}

export class SystemPrefecture {
  delivery_fee: number;
  less_than_price: number;
  prefecture_code: number;
  prefecture_name: string;
}

export class CustomerDeliveryAddress {
  id?: number;
  customer_code: string;
  name: string;
  postal_code: string;
  prefecture_code: number;
  address_1: string;
  address_2: string;
  tel_number: string;
  fax_number: string;
  supervisor_name: string;
  supervisor_f: string;
  busyo_name: string;
  is_enabled: boolean;
  system_prefecture?: SystemPrefecture;
  constructor(dto: Record<string, unknown>) {
    Object.assign(this, dto);
  }
}

export default class Customer extends CustomerDTO {
  constructor(dto: CustomerDTO) {
    super();
    Object.assign(this, dto);
  }
}
